import React from 'react';
import DQ from "./dq"
import Pipeline from "./pipeline"
import Verticalization from "./verticalization"
export default class LoadRealTimeCompoent extends React.Component {
    constructor(props, context) {
        super(props, context);
        const incidentDate = props.data?.date || null;
        this.state={
            selectedDate: incidentDate,
            showContent: false,
            cardName: "",
        }
      }

      componentDidMount() {
        // console.log("[INCIDENT_REDIRECT] 3. realtime loader props", {
        //   selectedTab: this.props.selectedTab,
        //   selectedEnvId: this.props.selectedEnvId,
        //   redirectData: this.props.data
        // });
      }

      componentDidUpdate(prevProps) {
      if (prevProps.data?.date !== this.props.data?.date) {
        const newDate = this.props.data?.date || null;
        this.setState({ selectedDate: newDate });
      }
    }

      render() {

        return (
        <>
        
        {
          this.props.selectedTab === "DQ" ?
           <DQ 
           selectedEnvId = {this.props.selectedEnvId}
          //  selectedEnvId = {3}
           selectedEnvName={this.props.selectedEnvName}
           teamId={this.props.teamId}
           userId={this.props.userId}
           tabId = {this.props.tabId}
           browserTabId={this.props.browserTabId}
           browserSessionId={this.props.browserSessionId}
           selectedTab = {this.props.selectedTab}
           data = {this.props.data}
           selectedDate={this.state.selectedDate}
           initialIntegrationId={this.props.data?.integration_id}
           initialDatasetId={this.props.data?.dataset_id}
           />  :
           this.props.selectedTab === "PIPELINE" ?
           <Pipeline 
           selectedEnvId = {this.props.selectedEnvId}
           selectedEnvName={this.props.selectedEnvName}
           teamId={this.props.teamId}
           userId={this.props.userId}
           tabId = {this.props.tabId}
           browserTabId={this.props.browserTabId}
           browserSessionId={this.props.browserSessionId}
           data = {this.props.data}
           selectedDate={this.state.selectedDate}
           /> :
           this.props.selectedTab === "VERTICAL" && this.props.selectedEnvId ?
           <Verticalization
                         monitorModule = {this.props.monitorModule}
           selectedEnvId = {this.props.selectedEnvId}
           selectedEnvName={this.props.selectedEnvName}
           teamId={this.props.teamId}
           userId={this.props.userId}
           tabId = {this.props.tabId}
           browserTabId={this.props.browserTabId}
           browserSessionId={this.props.browserSessionId}
           selectedTab = {this.props.selectedTab}
           data={this.props.data}
           />  :
           "Coming soon..."

        }
        </>)
      }
}
